import { Observable } from 'rxjs';
import { map, takeUntil} from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { CoreComponent } from '../core.component';

import { AuthService } from '@admin/auth/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class UserSyncAuthGuard extends CoreComponent implements CanActivate {

  constructor(private router: Router, private authService: AuthService) {
    super();
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.authService.isActimoIntegrationEnabled
      .pipe(
        takeUntil(this.destroyed$),
        map((response: boolean) => {
          const queryParams = (state.url === '/dashboard') ? {} : { queryParams: { returnUrl: state.url } };
          if (response) return true;
          else {
            this.router.navigate(['/dashboard'], queryParams);
            return false;
          }
        })
      )
  }
}
